import { render, staticRenderFns } from "./EventPlaylist.vue?vue&type=template&id=61841066&"
import script from "./EventPlaylist.vue?vue&type=script&lang=js&"
export * from "./EventPlaylist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports